import { motion } from "motion/react";
import type React from "react";
import { useTranslation } from "react-i18next";

const imgLogo = "/img/logo_word_color.svg";

export const ExpiredScreen: React.FC = () => {
	const { t } = useTranslation();

	return (
		<div className="bg-white flex flex-col items-center justify-center gap-10 min-h-screen p-5 relative w-full mx-auto overflow-hidden">
			{/* Logo */}
			<motion.div
				initial={{ opacity: 0, y: -20 }}
				animate={{ opacity: 1, y: 0 }}
				transition={{ duration: 0.5 }}
				className="w-[109px] h-[18px] shrink-0"
			>
				<img
					alt="inJOY Logo"
					className="w-full h-full object-contain"
					src={imgLogo}
				/>
			</motion.div>

			{/* Message */}
			<motion.div
				initial={{ opacity: 0 }}
				animate={{ opacity: 1 }}
				transition={{ duration: 0.5, delay: 0.2 }}
				className="flex flex-col items-center gap-3 text-center"
			>
				<h2 className="H6 font-semibold text-color_text_grey_5 text-[18px]">
					{t("guest.expired.title")}
				</h2>
				<p className="text-sm text-color_text_grey_4 max-w-[337px]">
					{t("guest.expired.message")}
				</p>
			</motion.div>
		</div>
	);
};
